import React from "react";
import { observer } from "mobx-react-lite";

import useModel from "./model/Model";

import Loading from "./components/Loading";
import Map from "./components/Map/Map";
import Toolbar from "./components/Toolbar";
import ColorSelector from "./components/ColorSelector";

const App = () => {
    const model = useModel();

    return (
        <div id="container">
            <Toolbar />
            <Map />
            {model.loading && <Loading />}
        </div>
    );
};

export default observer(App);
